import type { RouteLocationRaw } from 'vue-router';

const MODULE_MATRIX_REVISION_ROUTE_NAME = 'ModuleMatrixRevision';
const GENERATED_RECORDS_TAB = { tab: 'generated-records' };

export function matrixPageLocation(
  prefix: string,
  returnFolderCode: string | null,
  { generatedRecords = false }: { generatedRecords?: boolean } = {}
): RouteLocationRaw {
  const query = generatedRecords ? { query: GENERATED_RECORDS_TAB } : {};
  if (returnFolderCode) {
    return {
      name: MODULE_MATRIX_REVISION_ROUTE_NAME,
      params: { folderCode: returnFolderCode },
      ...query,
    };
  }
  return { name: 'QualityRecordMatrix', params: { prefix }, ...query };
}
